<template>
  <Dialog :commonDialog="personDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <span v-if="doUpdate">Update</span>
      <span v-else>Add</span>
      <span>&nbsp;Contact Person</span>
    </template>
    <template v-slot:body>
      <v-form
        ref="personForm"
        v-model.trim="formValid"
        lazy-validation
        v-on:submit.stop.prevent="appendContactPerson"
      >
        <v-row v-if="personDialog" class="mx-3">
          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="y-salutation"
              >Salutation</label
            >
            <v-select
              id="y-salutation"
              :menu-props="{ offsetY: true }"
              v-model.trim="contactPerson.title"
              :items="salutationList"
              dense
              filled
              :rules="[
                validateRules.required(contactPerson.title, 'salutation'),
                validateRules.validPersonName(
                  contactPerson.title,
                  'salutation'
                ),
              ]"
              item-text="text"
              item-value="value"
              item-color="cyan"
              placeholder="Salutation"
              solo
              flat
              color="cyan"
            ></v-select>
          </v-col>
          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="y-first_name"
              >First Name</label
            >
            <v-text-field
              id="y-first_name"
              v-model.trim="contactPerson.first_name"
              :rules="[
                validateRules.required(contactPerson.first_name, 'first name'),
                validateRules.minLength(contactPerson.first_name, 'first name', 2),
                validateRules.maxLength(contactPerson.first_name, 'first name', 50),
                validateRules.validPersonName(contactPerson.first_name, 'first name')
              ]"
              :maxlength="50"
              dense
              filled
              placeholder="First Name"
              solo
              flat
              color="cyan"
              class="required-field"
              v-on:keyup="appendDisplayName()"
            ></v-text-field>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-last_name"
              >Last Name</label
            >
            <v-text-field
              id="y-last_name"
              v-model.trim="contactPerson.last_name"
              :rules="[
                validateRules.minLength(contactPerson.last_name, 'last name', 2),
                validateRules.maxLength(contactPerson.last_name, 'last name', 50),
                validateRules.validPersonName(contactPerson.last_name, 'last name')
              ]"
              :maxlength="50"
              dense
              filled
              placeholder="Last Name"
              solo
              flat
              color="cyan"
              v-on:keyup="appendDisplayName()"
            ></v-text-field>
          </v-col>

          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="y-display_name"
              >Display Name</label
            >
            <v-text-field
              id="y-display_name"
              v-model.trim="contactPerson.display_name"
              :rules="[
                validateRules.required(contactPerson.display_name, 'display name'),
                validateRules.minLength(contactPerson.display_name, 'display name', 2),
                validateRules.maxLength(contactPerson.display_name, 'display name', 120),
                validateRules.validPersonName(contactPerson.display_name, 'display name')
              ]"
              :maxlength="120"
              dense
              filled
              placeholder="Display Name"
              solo
              flat
              color="cyan"
              class="required-field"
            ></v-text-field>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="email"
              >Email Address</label
            >

            <v-text-field
              id="email"
              v-model.trim="contactPerson.email"
              :rules="[
                validateRules.validEmail(contactPerson.email, 'email'),
                validateRules.minLength(contactPerson.email, 'Email', 2),
                validateRules.maxLength(contactPerson.email, 'email', 100),
              ]"
              :maxlength="100"
              dense
              filled
              placeholder="Email Address"
              solo
              flat
              color="cyan"
              class="required-field"
            ></v-text-field>
          </v-col>

          <v-col md="4" class="">
            <label class="font-size-16 font-weight-500 ml-1" for="Designation"
              >Position</label
            >
            <v-autocomplete
              :items="designations"
              v-model.trim="contactPerson.designation"
              dense.
              filled
              color="cyan"
              item-color="cyan"
              solo
              flat
              append-outer-icon="mdi-cog"
              placeholder="Position"
              v-on:click:append-outer="manageDesignationDialog = true"
              item-text="text"
              item-value="text"
              class="width-100 new-height"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="'No Position(s) Found.'"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>

            <template>
              <ManageCustomerdesignation
                :dialog="manageDesignationDialog"
                :e_designation="designations"
                v-on:close-dialog="manageDesignationDialog = false"
                v-on:get-e-designation="setOptions"
              ></ManageCustomerdesignation>
            </template>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-primary_phone"
              >Mobile Number</label
            >
            <PhoneTextField
              id="y-phone"
              v-model="contactPerson.phone"
              :phoneKey="1"
              label="Mobile Number"
            >
            </PhoneTextField>
          </v-col>
          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-did">
              DID
            </label>
            <PhoneTextField
              id="y-did"
              v-model="contactPerson.did"
              :phoneKey="2"
              label="DID"
            >
            </PhoneTextField>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-landline">
              Landline Number
            </label>
            <PhoneTextField
              id="y-did"
              v-model="contactPerson.landline"
              :phoneKey="3"
              label="Landline Number"
            >
            </PhoneTextField>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:action>
      <v-btn
        v-on:click="$emit('close', true)"
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
      >
        Cancel
      </v-btn>
      <v-btn
        class="mx-2 custom-bold-button white--text"
        v-on:click="appendContactPerson"
        color="cyan"
        depressed
        :disabled="!formValid"
      >
        <span v-if="doUpdate">Update</span>

        <span v-else>Add</span>
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import { v4 as uuidv4 } from "uuid";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Dialog from "@/view/pages/partials/Dialog";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import { PUT, GET } from "@/core/services/store/request.module";
import ManageCustomerdesignation from "@/view/pages/partials/Manage-Customerdesignation.vue";
//import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
export default {
  model: {
    prop: "value",
    event: "input",
  },
  mixins: [ValidationMixin, CommonMixin],
  data() {
    return {
      manageDesignationDialog: false,
      designations: [],
      formValid: false,
      contactPersons: [],
      contactPerson: {
        id: null,
        title: "mr",
        first_name: null,
        last_name: null,
        display_name: null,
        name: null,
        email: null,
        designation: null,
        phone: null,
        did: null,
        landline: null,
        primary: 0,
        default: 0,
        will_notified: 1,
        type: null,
        customer: null,
        lead: null,
      },
    };
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    personDialog: {
      type: Boolean,
      default: false,
    },

    doSave: {
      type: Boolean,
      default: false,
    },
    doUpdate: {
      type: Boolean,
      default: false,
    },
    leadId: {
      type: Number,
      default: 0,
    },

    personId: {
      type: Number,
      default: 0,
    },

    lead: {
      type: Object,
      default: null,
    },

    personUuid: {
      type: String,
      default: null,
    },

    personAlldata: {
      type: Object,
      default: null,
    },

    disableOne: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.contactPersons = cloneDeep(newVal || []);
      },
    },

    personDialog() {
      this.initComponent();
    },

    personAlldata(param) {
      if (param) {
        this.contactPerson = param;
      } else {
        this.contactPerson = {};
      }
    },
  },
  methods: {
    initComponent() {
      const result = this.lodash.cloneDeep(this.value);
      this.contactPersons = result;

      if (this.doUpdate) {
        this.$nextTick(() => {
          let contact_person = this.lodash.find(this.contactPersons, {
            id: this.personId,
          });

          if (!contact_person) {
            contact_person = this.lodash.find(this.contactPersons, {
              uuid: this.personUuid,
            });
          }

          if (contact_person) {
            this.$nextTick(() => {
              this.contactPerson = {
                id: contact_person.id,
                uuid: contact_person.uuid,
                lead: contact_person.lead,
                title: "mr",
                first_name: contact_person.first_name || contact_person.name,
                last_name: contact_person.last_name,
                display_name:
                  contact_person.display_name || contact_person.name,
                name: contact_person.name,
                email: contact_person.email || contact_person.primary_email,
                designation: contact_person.designation,
                phone: contact_person.phone || contact_person.primary_phone,
                did: contact_person.did,
                landline: contact_person.landline,
                primary: +(contact_person.primary ?? contact_person.default),
                will_notified: +contact_person.will_notified,
              };
            });
          }
        });
      } else {
        this.$nextTick(() => {
          let contactIndex = this.contactPersons.length + 1;
          this.contactPerson = {
            id: null,
            uuid: uuidv4(),
            lead: null,
            title: "mr",
            first_name: null,
            last_name: null,
            display_name: null,
            name: null,
            email: null,
            designation: null,
            phone: null,
            did: null,
            landline: null,
            primary: 0,
            will_notified: 1,
            contactIndex: contactIndex,
          };
        });
      }
    },

    resetForm() {
      this.contactPerson = {
        id: null,
        uuid: uuidv4(),
        title: "mr",
        first_name: null,
        last_name: null,
        display_name: null,
        name: null,
        email: null,
        designation: null,
        phone: null,
        did: null,
        landline: null,
        primary: 0,
        will_notified: 1,
      };
      this.formValid = false;
    },
    appendDisplayName() {
      const nameParts = [];
      const { first_name, last_name } = this.contactPerson;

      if (first_name) {
        nameParts.push(first_name);
      }
      if (last_name) {
        nameParts.push(last_name);
      }

      this.contactPerson.display_name = nameParts.join(" ");
      this.contactPerson.name = this.contactPerson.display_name;
    },
    setOptions() {
      let _this = this;
      _this.$store
        .dispatch(GET, {
          url: "get-customer-designation",
        })
        .then(({ data }) => {
          _this.designations = this.lodash.map(
            data.customer_designation,
            function (row) {
              return {
                text: row.text,
                value: row.id,
              };
            }
          );
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    async appendContactPerson() {
      this.contactPerson.name = this.contactPerson.display_name;

      if (!this.$refs.personForm.validate()) return;
      let contactId = this.contactPerson.id;
      let temp_persons = this.lodash.cloneDeep(this.contactPersons);

      if (!this.disableOne) {
        if (!contactId) {
          if (this.personUuid) {
            let existIndex = this.lodash.findIndex(temp_persons, {
              uuid: this.personUuid,
            });
            if (existIndex >= 0) {
              temp_persons.splice(existIndex, 1, {
                uuid: this.contactPerson.uuid,
                id: this.contactPerson.id,
                title: this.contactPerson.title,
                  first_name: this.contactPerson.first_name,
                  last_name: this.contactPerson.last_name,
                  display_name: this.contactPerson.display_name,
                name: this.contactPerson.name,
                email: this.contactPerson.email,
                designation: this.contactPerson.designation,
                phone: this.contactPerson.phone,
                did: this.contactPerson.did,
                landline: this.contactPerson.landline,
                primary: this.contactPerson.primary,
                will_notified: this.contactPerson.will_notified,
                contactIndex: this.contactPerson.contactIndex,
              });
            }
          } else {
            temp_persons.push({
              id: this.contactPerson.id,
              uuid: this.contactPerson.uuid,
              title: this.contactPerson.title,
              first_name: this.contactPerson.first_name,
              last_name: this.contactPerson.last_name,
              display_name: this.contactPerson.display_name,
              name: this.contactPerson.name,
              email: this.contactPerson.email,
              designation: this.contactPerson.designation,
              phone: this.contactPerson.phone,
              did: this.contactPerson.did,
              landline: this.contactPerson.landline,
              primary:
                temp_persons.length === 0 ? 1 : this.contactPerson.primary,
              will_notified: this.contactPerson.will_notified,
              contactIndex: this.contactPerson.contactIndex,
            });
          }

          this.$emit("input", temp_persons);
          this.$emit("update:person", this.contactPerson);
          this.$emit("close", true);
          return false;
        }
      }

      if (!this.contactPerson.contactIndex) {
        this.contactPersons.push({
          id: this.contactPerson.id,
          uuid: this.contactPerson.uuid,
          title: this.contactPerson.title,
          first_name: this.contactPerson.first_name,
          last_name: this.contactPerson.last_name,
          display_name: this.contactPerson.display_name,
          name: this.contactPerson.name,
          email: this.contactPerson.email,
          designation: this.contactPerson.designation,
          phone: this.contactPerson.phone,
          did: this.contactPerson.did,
          landline: this.contactPerson.landline,
          primary:
            this.contactPersons.length === 0 ? 1 : this.contactPerson.primary,
          will_notified: this.contactPerson.will_notified,
          contactIndex: this.contactPerson.contactIndex,
        });
      } else {
        this.contactPersons[this.contactPerson.contactIndex - 1] = {
          id: this.contactPerson.id,
          uuid: this.contactPerson.uuid,
          title: this.contactPerson.title,
          first_name: this.contactPerson.first_name,
          last_name: this.contactPerson.last_name,
          display_name: this.contactPerson.display_name,
          name: this.contactPerson.name,
          email: this.contactPerson.email,
          designation: this.contactPerson.designation,
          phone: this.contactPerson.phone,
          did: this.contactPerson.did,
          landline: this.contactPerson.landline,
          primary: this.contactPerson.primary,
          will_notified: this.contactPerson.will_notified,
          contactIndex: this.contactPerson.contactIndex,
        };
      }

      if (this.contactPerson.contactIndex) {
        this.doUpdate = false;
      }
      if (this.doSave || this.doUpdate) {
        try {
          const uuid = uuidv4();
          this.contactPerson.uuid = uuid;
          const payloadPerson = {
            id: this.contactPerson.id,
            uuid,
            title: this.contactPerson.title,
            first_name: this.contactPerson.first_name,
            last_name: this.contactPerson.last_name,
            display_name: this.contactPerson.display_name,
            primary_email: this.contactPerson.email,
            primary_phone: this.contactPerson.phone,
            did: this.contactPerson.did,
            landline: this.contactPerson.landline,
            will_notified: this.contactPerson.will_notified,
            position: null,
            default: this.contactPerson.primary,
            designation: this.contactPerson.designation,
            type: "lead",
            customer: null,
            lead: this.leadId,
            tenant: 0,
          };

          const { data } = await this.$store.dispatch(PUT, {
            url: `customer/${this.leadId}/contact-person`,
            data: { persons: [payloadPerson], type: "lead" },
          });

          this.contactPerson = this.lodash.find(data, { uuid });
          this.contactPersons = data;
          this.$emit("input", this.contactPersons);
          this.$emit("update:person", this.contactPerson);
        } catch (error) {
          this.logError(error);
          return;
        }
      } else {
        this.contactPersons.push({ ...this.contactPerson, id: null });
        this.$emit("input", this.contactPersons);
      }

      this.resetForm();
      this.$emit("close", true);
    },
  },
  components: {
    Dialog,
    PhoneTextField,
    ManageCustomerdesignation,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
    },
  },
  mounted() {
    this.initComponent();
    this.setOptions();
  },
};
</script>
